var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPillar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 150,
    viewBox: "0 0 130 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 27L97 44L64.5 62L32 44L64.5 27Z",
    fill: "url(#paint0_linear_102_43)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 100.532V43.9377L64.4943 62V124.008L32 100.532Z",
    fill: "url(#paint1_linear_102_43)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9895 100.532V43.9376L64.4952 62V124.008L96.9895 100.532Z",
    fill: "url(#paint2_linear_102_43)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_102_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5 62V107",
    stroke: "url(#paint3_linear_102_43)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_102_43",
    x: 62,
    y: 60,
    width: 5,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_102_43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_43",
    x1: 65.2738,
    y1: 57.4376,
    x2: 64.7424,
    y2: 14.9949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC97C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468239,
    stopColor: "#249F67",
    stopOpacity: 0.674767
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17493A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_43",
    x1: 50.8812,
    y1: 52.5074,
    x2: 30.2761,
    y2: 116.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC97C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17493A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_102_43",
    x1: 79.203,
    y1: 52.5073,
    x2: 98.8049,
    y2: 116.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC97C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17493A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_102_43",
    x1: 64.5,
    y1: 62,
    x2: 64.5,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC97C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BC97C",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillar);
export default __webpack_public_path__ + "static/media/pillar.d1602f91846db076c4682561b93dc39b.svg";
export { ForwardRef as ReactComponent };